import './index.scss'
$("#nav8").addClass("active");
$(".section2 ul li").eq(0).addClass("active");
$(".section2 .map .maps").eq(0).addClass("active");
$(".section2 ul li").click(function () {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".section2 .map .maps").eq(index).addClass("active").siblings().removeClass("active");
})